module.exports = __webpack_public_path__ + "img/node-storage-transparent.b4bb5dde.webp";